// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gw-backdrop{overflow:hidden;position:relative;z-index:1}.gw-backdrop__graphic{left:50%;max-height:100%;min-width:1000px;position:absolute;top:50%;transform:translate(-50%,-50%);width:100vw;z-index:-1}.gw-backdrop--static{height:50vh}.gw-backdrop--static .gw-backdrop__graphic{min-width:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
